<div class="container st-form">
  <div class="col2 d-grid gap-2 d-md-flex justify-content-md-start align-items-start">
    <!--<app-st-button [idVal]="'sign-out-button-id'" [label]="'Sign Out'" [primary]="true"
                   (click)="this.onLogout()"></app-st-button>-->
    <a [id]="'sign-out-button-id'"
                   (click)="this.onLogout()"><b class="webtext-teal-bold">Sign Out</b></a>
  </div>
</div>
